import { TravailStubPage } from '../../../../components/parcours/TravailStubPage';
import { getTravailStub } from '../../../../config/travaux-particuliers';

export default function ChauffeEauSolairePage() {
  const travail = getTravailStub('chauffe-eau-solaire');
  if (!travail) return null;
  return <TravailStubPage travail={travail} />;
}
